export default "__VITE_ASSET__iwbTTcOx__"